export default __webpack_public_path__ + "assets/images/02a254728712e93cf4a626f6eecfe785.jpg";